/**
 * use-ai-bot-status.ts — GET /ai/bots/:id/status ("Đang trả lời / Chưa trả lời vì…" của một nhân viên AI, khung ba tầng).
 * Khoá nằm dưới `aiKeys.bots` → mọi chỗ làm mới danh sách nhân viên AI cũng làm mới trạng thái.
 */
import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api-client'
import { aiKeys, type AiBotStatus } from '@/hooks/use-ai'

export const botStatusKey = (botId: string) => [...aiKeys.bots, botId, 'status'] as unknown[]

export function useAiBotStatus(botId: string | undefined, opts: { enabled?: boolean } = {}) {
  return useQuery<AiBotStatus>({
    queryKey: botStatusKey(botId ?? ''),
    enabled: !!botId && opts.enabled !== false,
    queryFn: async () => (await api.get<AiBotStatus>(`/ai/bots/${botId}/status`)).data,
    staleTime: 10_000,
    retry: false,
    // Lý do chặn thường được sửa ở màn khác (mở ở tab mới: Nguồn AI và lượt AI, Kết nối…) → quay lại tab là kiểm tra lại.
    refetchOnWindowFocus: true,
  })
}
